/**
 * Operating System detection utility
 * Supports Windows, Mac, Linux, and other platforms
 */

export enum OperatingSystem {
  WINDOWS = 'windows',
  MAC = 'mac',
  LINUX = 'linux',
  OTHER = 'other',
}

/**
 * Detects the current operating system
 * @returns OperatingSystem enum value
 */
export function detectOS(): OperatingSystem {
  if (typeof navigator === 'undefined') {
    return OperatingSystem.OTHER;
  }

  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('win')) {
    return OperatingSystem.WINDOWS;
  }

  if (
    userAgent.includes('mac') ||
    userAgent.includes('macintosh') ||
    userAgent.includes('mac os')
  ) {
    return OperatingSystem.MAC;
  }

  if (userAgent.includes('linux') || userAgent.includes('x11')) {
    return OperatingSystem.LINUX;
  }

  return OperatingSystem.OTHER;
}

/**
 * Checks if the current platform is Mac
 * @returns boolean
 */
export function isMacPlatform(): boolean {
  return detectOS() === OperatingSystem.MAC;
}

/**
 * Checks if the current platform is Windows
 * @returns boolean
 */
export function isWindowsPlatform(): boolean {
  return detectOS() === OperatingSystem.WINDOWS;
}

/**
 * Checks if the current platform is Linux
 * @returns boolean
 */
export function isLinuxPlatform(): boolean {
  return detectOS() === OperatingSystem.LINUX;
}
